import { render, staticRenderFns } from "./InformacoesMaterial.vue?vue&type=template&id=50616634&scoped=true&"
import script from "./InformacoesMaterial.vue?vue&type=script&lang=js&"
export * from "./InformacoesMaterial.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesMaterial.vue?vue&type=style&index=0&id=50616634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50616634",
  null
  
)

export default component.exports